// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backBlur {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba(249, 249, 249, 0.27);
}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/loader/loader.component.scss"],"names":[],"mappings":"AAWA;EACI,eAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,2CAAA;AAVJ","sourcesContent":["// .loadesr {\n//     position: fixed;\n//     left: 0px;\n//     top: 0px;\n//     width: 100%;\n//     height: 100%;\n//     z-index: 9999;\n//     background: url(\"/assets/images/Loader02.gif\") 50% 50% no-repeat rgb(249, 249, 249);\n//     background-color: rgb(249, 249, 249, 0.50);\n// }\n\n.backBlur {\n    position: fixed;\n    left: 0px;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    background-color: rgb(249 249 249 / 27%);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
